import { ILogger } from '@cian/logger';

import { ChatMessageValidationError, ChatOfferValidationError, ChatUsersValidationError } from '../errors';
import { IChat } from '../types/chatList';

interface IValidateChatItemParameters {
  chat?: IChat;
  logger?: ILogger;
}

const DOMAIN = 'utils.validate.validateChatItem';

export function validateChatItem({ chat, logger }: IValidateChatItemParameters): boolean {
  try {
    if (!chat) {
      throw new ChatOfferValidationError({
        message: `В чате отсутствуют корректные данные (chat is undefined)`,
        domain: DOMAIN,
      });
    }

    if (!chat.lastMessage) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage, chatId: ${chat.chatId}`,
        domain: DOMAIN,
        details: {
          chatId: chat.chatId,
        },
      });
    }

    if (!('userId' in chat.lastMessage)) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage.userId, chatId: ${chat.chatId}`,
        domain: DOMAIN,
        details: {
          chatId: chat.chatId,
          messageId: chat.lastMessage['messageId'],
        },
      });
    }

    // поле теxt может быть необязательным, если это сообщение с вложением
    if (!('text' in chat.lastMessage) && !['offer', 'textAndFiles'].includes(chat.lastMessage.type)) {
      throw new ChatMessageValidationError({
        message: `В чате отсутствует поле lastMessage.text, chatId: ${chat.chatId}, message.type: ${chat.lastMessage['type']}`,
        domain: DOMAIN,
        details: {
          chatId: chat.chatId,
          messageId: chat.lastMessage['messageId'],
        },
      });
    }

    if (!chat.users) {
      throw new ChatUsersValidationError({
        message: `В чате отсутствует поле users, chatId: ${chat.chatId}`,
        domain: DOMAIN,
        details: {
          chatId: chat.chatId,
        },
      });
    }

    return true;
  } catch (error) {
    if (logger) {
      logger.error(error);
    } else {
      console.error(error);
    }

    return false;
  }
}
